import React, { Fragment, useState, useEffect, useContext } from "react";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Button from "@mui/material/Button";
import TicketsModal from "../../components/modals/TicketsModal";
import LoadingButton from "@mui/lab/LoadingButton";
import Skeleton from "@mui/material/Skeleton";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useAppContext } from "../../AppContext";
import { useTheme } from "@mui/material/styles";
import axios from "axios";
import CircularTable from "../../public/images/circularTable.png";
import Image from "next/image";
import Router from "next/router";

function Tickets(props) {
  const theme = useTheme();
  const {
    url,
    themeData,
    siteData,
    themeLoading,
    siteLoading,
    themeError,
    siteError,
    changeUrl,
    updateThemeData,
    updateSiteData,
  } = useAppContext();
  const [themeCss, setThemeCss] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  useEffect(() => {
    let custom_css =
      themeData && themeData
        ? JSON.parse(themeData && themeData.custom_css)
        : null;
    setThemeCss(custom_css);
    setLoading(false);
  }, [themeData]);

  const ticketsModalHandler = () => {
    setOpen(true);
    setLoading(true);
  };

  const onCloseTicketsModalHandler = () => {
    setOpen(false);
    setLoading(false);
  };

  const onCloseTicketsModalHandlerAlert = () => {
    setOpen(false);
    setLoading(false);
  };

  const onCloseTicketsModalHandlerAlert1 = () => {
    setOpen1(false);
    setLoading(false);
  };

  const [uniqueId, setUniqueId] = useState(props.uniqueId);

  useEffect(() => {
    setUniqueId(props.uniqueId);
    // setIsLoading(false);
  }, [props.uniqueId]);

  const ticketsCard = {
    backgroundColor: theme.palette.background.alternate,
    padding: theme.spacing(3),
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    border: `1px solid`,
    borderColor: theme.palette.background.borderColor,
    borderRadius: 2.5,
    "& h4": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 22,
      color: theme.palette.primary.contrastText,
      textTransform: "capitalize !important",
      [theme.breakpoints.down("md")]: {
        fontSize: 16,
      },
    },
    "& h5": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 14,
      fontWeight: 400,
      color: theme.palette.primary.contrastText,
    },
    "& h6": {
      fontFamily:
        themeCss && themeCss.theme_body_font
          ? themeCss.theme_body_font.replace("+", " ")
          : "",
      fontSize: 16,
      color: theme.palette.primary.location,
      fontWeight: 400,
      marginTop: theme.spacing(0.75),
      marginBottom: theme.spacing(0.75),
    },
    [theme.breakpoints.down("md")]: {
      marginTop: 0,
      marginBottom: 0,
      position: "fixed",
      left: theme.spacing(3),
      right: theme.spacing(3),
      bottom: theme.spacing(2),
      zIndex: 3,
      borderRadius: `15px`,
      boxShadow: theme.shadows[6],
      padding: theme.spacing(2),
    },
  };

  const [showReserveTablesButton, setShowReserveTablesButton] = useState(false);

  useEffect(() => {
    axios
      .get(`/api/events/checkTablesTaggedToEvent?eventId=${props.data.id}`, {
        headers: {
          "x-auth-token": process.env.JWT_TOKEN,
        },
      })
      .then((resp) => {
        setShowReserveTablesButton(resp.data);
        setIsLoading(false)
      })
      .catch((err) => {
        setShowReserveTablesButton(false);
        setIsLoading(false)
      });
  }, [props]);

  const gotoTables = (event) => {
    event.preventDefault();
    Router.push(`/tables/${props.data.slug}/${props.data.id}`, undefined, {
      shallow: true,
    });
  };

  return (
    <>
      {isLoading ? (
        <Skeleton
          variant="rectangular"
          height={100}
          sx={{ borderRadius: "20px" }}
        />
      ) : (
        <Typography component="div" sx={ticketsCard}>
          <Paper elevation={0}>
            {props.isEventActive != 0 ? (
              props.tickets.length > 0 ? (
                props.ticketStatus ? (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={0}
                  >
                    <Typography
                      variant="h4"
                      className="desktopMode"
                      sx={{ alignItems: "center", display: "flex" }}
                    >
                      {props.reserveStatus && props.starting ? (
                        <>
                          <Typography
                            component="span"
                            variant="h6"
                            sx={{ fontSize: 15 }}
                          >
                            Starts at{" "}
                          </Typography>
                          <CurrencyRupeeIcon sx={{ fontSize: "15px" }} />
                          <b>{props.starting}</b>
                        </>
                      ) : (
                        <Typography
                          variant="p"
                          sx={{ fontSize: 15, textTransform: "capitalize" }}
                        >
                          {"Reserve for Free".toLowerCase()}
                        </Typography>
                      )}
                    </Typography>
                    <Typography
                      variant="h4"
                      className="mobileMode"
                      sx={{ alignItems: "center", display: "flex" }}
                    >
                      {props.reserveStatus && props.starting ? (
                        <>
                          <Typography
                            component="span"
                            variant="h6"
                            sx={{ fontSize: 15 }}
                          >
                            Starts at{" "}
                          </Typography>
                          <CurrencyRupeeIcon sx={{ fontSize: "15px" }} />
                          <b>{props.starting}</b>
                        </>
                      ) : (
                        <Typography
                          variant="p"
                          sx={{ fontSize: 20, textTransform: "capitalize" }}
                        >
                          {"Reserve for Free".toLowerCase()}
                        </Typography>
                      )}
                    </Typography>
                    <Typography
                      component="div"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                      }}
                      onClick={ticketsModalHandler}
                    >
                      {/* <Typography component="h5" sx={{mb:0}}>Book Now</Typography>  */}
                      <Typography
                        variant="span"
                        className="rippleBtn"
                        sx={{
                          "&.rippleBtn span": {
                            background: themeCss && themeCss.theme_main_color,
                            border: `2px solid ${
                              themeCss && themeCss.theme_main_color
                            }`,
                            color:
                              themeCss && themeCss.theme_primary_font_color,
                          },
                          "&.rippleBtn span:before": {
                            background: themeCss && themeCss.theme_main_color,
                            border: `2px solid ${
                              themeCss && themeCss.theme_main_color
                            }`,
                            color:
                              themeCss && themeCss.theme_primary_font_color,
                          },
                        }}
                      >
                        <span>
                          <ArrowForwardIcon
                            sx={{
                              fontSize: "14px",
                              color: theme.palette.primary.arrowColor,
                              zIndex: 3,
                              zIndex: 3,
                            }}
                          />
                        </span>
                      </Typography>
                    </Typography>
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    spacing={3}
                  >
                    <Stack
                      justifyContent="flex-start"
                      alignItems="start"
                      spacing={1}
                      direction="column"
                    >
                      <Typography variant="h4">
                        Sorry! Event is sold out
                      </Typography>
                      <Typography
                        component="h6"
                        sx={{
                          display: {
                            xl: "block",
                            lg: "block",
                            md: "block",
                            sm: "none",
                            xs: "none",
                          },
                          fontSize: 12,
                        }}
                      >
                        Currently, no tickets are available through Clubr!
                        Discover similar events in this genre, and breeze
                        through checkout.
                      </Typography>
                    </Stack>
                    <Button
                      sx={{
                        py: 1,
                        px: 2,
                        alignSelf: "center",
                        minWidth: "150px",
                      }}
                      variant="outlined"
                      className="themeBtnAlt"
                      disabled={true}
                    >
                      Sold Out
                    </Button>
                  </Stack>
                )
              ) : (
                <>
                  {showReserveTablesButton ? (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={0}
                      onClick={(e) => gotoTables(e)}
                      sx={{ cursor: "pointer" }}
                    >
                      <Typography
                        variant="h4"
                        className="desktopMode"
                        sx={{ alignItems: "center", display: "flex" }}
                      >
                        <>
                          <Typography
                            component="span"
                            variant="h6"
                            sx={{ fontSize: 15 }}
                          >
                            Book Your Table{" "}
                          </Typography>
                        </>
                      </Typography>
                      <Typography
                        variant="h4"
                        className="mobileMode"
                        sx={{ alignItems: "center", display: "flex" }}
                      >
                        <Typography
                          component="span"
                          variant="h6"
                          sx={{ fontSize: 15 }}
                        >
                          Book Your Table{" "}
                        </Typography>
                      </Typography>
                      <Typography
                        component="div"
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        <Typography
                          variant="span"
                          className="rippleBtn"
                          sx={{
                            "&.rippleBtn span": {
                              background: themeCss && themeCss.theme_main_color,
                              border: `2px solid ${
                                themeCss && themeCss.theme_main_color
                              }`,
                              color:
                                themeCss && themeCss.theme_primary_font_color,
                            },
                            "&.rippleBtn span:before": {
                              background: themeCss && themeCss.theme_main_color,
                              border: `2px solid ${
                                themeCss && themeCss.theme_main_color
                              }`,
                              color:
                                themeCss && themeCss.theme_primary_font_color,
                            },
                          }}
                        >
                          <span>
                            <ArrowForwardIcon
                              sx={{
                                fontSize: "14px",
                                color: theme.palette.primary.arrowColor,
                                zIndex: 3,
                                zIndex: 3,
                              }}
                            />
                          </span>
                        </Typography>
                      </Typography>
                    </Stack>
                  ) : (
                    // <Typography
                    //   component="div"
                    //   sx={{ px: 4, mt: 3 }}
                    //   onClick={(e) => gotoTables(e)}
                    // >
                    //   <Stack
                    //     display="flex"
                    //     flexDirection="row"
                    //     alignItems="center"
                    //     justifyContent="space-between"
                    //     sx={{
                    //       background: `${
                    //         themeCss && themeCss.theme_main_color
                    //       } !important`,
                    //       p: 1.5,
                    //       borderRadius: theme.spacing(1),
                    //     }}
                    //   >
                    //     <Stack
                    //       display="flex"
                    //       flexDirection="row"
                    //       alignItems="center"
                    //       sx={{ width: "100%" }}
                    //     >
                    //       <Image
                    //         src={CircularTable}
                    //         alt="..."
                    //         height="40"
                    //         width="40"
                    //       />
                    //       <Typography
                    //         variant="h5"
                    //         sx={{
                    //           ml: 4,
                    //           fontWeight: 500,
                    //           fontSize: 16,
                    //           color: theme.palette.background.default,
                    //         }}
                    //       >
                    //         Book Your Table
                    //       </Typography>
                    //     </Stack>
                    //     <Typography
                    //       component="div"
                    //       sx={{ cursor: "pointer" }}
                    //       onClick={(e) => gotoTables(e)}
                    //     >
                    //       <span
                    //         className="rippleBtnAlt"
                    //         style={{
                    //           padding: "10px 0px",
                    //           display: "flex",
                    //           alignItems: "center",
                    //           color: theme.palette.background.default,
                    //         }}
                    //       >
                    //         <span>
                    //           <ArrowForwardIcon
                    //             sx={{
                    //               fontSize: "14px",
                    //               color: `${
                    //                 themeCss && themeCss.theme_main_color
                    //               } !important`,
                    //               zIndex: 3,
                    //             }}
                    //           />
                    //         </span>
                    //       </span>
                    //     </Typography>
                    //   </Stack>
                    // </Typography>
                    <Stack
                      direction="column"
                      justifyContent="space-between"
                      spacing={0}
                    >
                      <Typography variant="h4">
                        {"Score Tickets at the Venue".toLowerCase()}.
                      </Typography>
                      <Typography
                        component="h6"
                        sx={{
                          display: {
                            xl: "block",
                            lg: "block",
                            md: "block",
                            sm: "none",
                            xs: "none",
                          },
                          fontSize: 12,
                        }}
                      >
                        Currently, no tickets are available through Clubr!
                        Discover similar events in this genre, and breeze
                        through checkout.
                      </Typography>
                    </Stack>
                  )}
                </>
              )
            ) : (
              <Stack
                direction="column"
                justifyContent="space-between"
                spacing={0}
              >
                <Typography variant="h4">
                  Sorry, you&apos;ve missed this event.
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    display: {
                      xl: "block",
                      lg: "block",
                      md: "block",
                      sm: "none",
                      xs: "none",
                    },
                    fontSize: 12,
                  }}
                >
                  Discover similar events in this genre, and breeze through
                  checkout.
                </Typography>
              </Stack>
            )}
          </Paper>
        </Typography>
      )}
      <TicketsModal
        open={open}
        onClose={onCloseTicketsModalHandler}
        onCloseAlert={onCloseTicketsModalHandlerAlert}
        onCloseAlert1={onCloseTicketsModalHandlerAlert1}
        tickets={props.tickets}
        event={props.data}
        uniqueId={uniqueId}
      />
    </>
  );
}

export default Tickets;
